import { Theme, useMediaQuery } from '@planne-software/uni/mui/material';
import { resolveVoucherDownloadPlacement, VoucherDownloadPlacement, type Voucher } from '@src/domains/vouchers';
import { LayoutColors } from '@src/core/theme';
import React from 'react';
import { FiDownloadCloud } from 'react-icons/fi';
import styled from 'styled-components';
import DotFalling from '@src/components/reusable/spinner/DotFalling';
import { baseButton } from '@src/components/Account/shared';

type ReservationDownloadButtonProps = {
  hasMultipleVouchers: boolean;
  hasPendingVouchers: boolean;
  text: string;
  isVoucherPdfLoading: (voucher: Voucher) => boolean;
  onOpenVoucherPdfButtonClick: (voucher: Voucher) => void;
  vouchers: Voucher[];
};

const ReservationDownloadButton = (props: ReservationDownloadButtonProps) => {
  const { hasMultipleVouchers, hasPendingVouchers, text, isVoucherPdfLoading, onOpenVoucherPdfButtonClick, vouchers } =
    props;
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const placement = resolveVoucherDownloadPlacement({ vouchers, hasMultipleVouchers, isMobile });
  const firstVoucher = vouchers[0];

  if (!firstVoucher) {
    return null;
  }

  if (placement === VoucherDownloadPlacement.Header) {
    return (
      <Button
        onClick={() => onOpenVoucherPdfButtonClick(firstVoucher)}
        disabled={hasPendingVouchers || isVoucherPdfLoading(firstVoucher)}
      >
        {isVoucherPdfLoading(firstVoucher) ? (
          <DotFalling />
        ) : (
          <>
            <FiDownloadCloud color={LayoutColors.whiteLight} size={22} />
            <ReservationViewText>{text}</ReservationViewText>
          </>
        )}
      </Button>
    );
  }

  return null;
};

export default ReservationDownloadButton;

const ReservationViewText = styled.span`
  display: inline;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  text-transform: uppercase;
`;

const Button = styled.button`
  ${baseButton};

  color: ${LayoutColors.whiteLight};
  background: ${LayoutColors.justBlue};
  white-space: nowrap;

  & > svg {
    flex-shrink: 0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
